import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { fetchJson } from "../../lib/Fetching";
import { customStyles } from "./DropDownStyles";
import { fetchDataFieldNames } from "./Utils/DataFieldNamesFetch";

export default class DataFieldsDropDown extends React.Component {
  state = {
    options: []
  };

  fetchData = () => {
    const { company_id, company_branch_id } = this.props;
    fetchDataFieldNames({ company_id, company_branch_id }).then(json => {
      var options = json.data_field_names.map(m => ({ label: m.name, value: m.id }));
      this.setState({ options });
    });
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.company_branch_id !== this.props.company_branch_id) {
      this.fetchData();
    }
  }

  render() {
    const { onChange, values } = this.props;
    const { options } = this.state;
    return (
      <Select
        options={options}
        value={values}
        placeholder={"Select"}
        isMulti
        styles={customStyles()}
        onChange={onChange}
        isClearable={true}
      />
    );
  }
}
